
export const AUTH_TOKEN = "J_AUTH_TOKEN";
export const REFRESH_TOKEN = "J_REFRESH_TOKEN";

export const SKU_TAG_COUNT = 7; // This really only works for joyya at this time

export const ABSENT_WITH_REASON = 'ABSENT_WITH_REASON';

export const STATUS_OPTIONS = [
    {
        key: 'Absent-Village',
        text: 'In village',
        value:'VILLAGE',
    },
    {
        key: 'Absent-Education',
        text: 'Other education',
        value:'EDUCATION',
    },
    {
        key: 'Absent-Wedding',
        text: 'Wedding',
        value: 'WEDDING',
    },
    {
        key: 'Absent-Funeral',
        text: 'Funeral',
        value: 'FUNERAL',
    },
    {
        key: 'Absent-Sickness',
        text: 'Sickness',
        value: 'SICKNESS',
    },
    {
        key: 'Absent-Religious-Festival',
        text: 'Religious Festival',
        value: 'RELIGIOUS',
    },
    {
        key: 'Absent-With-REASON',
        text: 'Other reason',
        value: ABSENT_WITH_REASON,
    },
    {
        key: 'PENDING',
        text: 'Pending',
        value: 'PENDING'
    },
];

export const FULL_STATUS_OPTIONS = [
    ...STATUS_OPTIONS,
    {
        key: 'ABSENT',
        text: 'Absent',
        value: 'ABSENT',
    },
    {
        key: 'PRESENT',
        text: 'Present',
        value: 'PRESENT',
    },
];

/**
 * Length limits for authored post text.
 *
 * Mirrors `POST_TITLE_MAX_LENGTH` / `POST_DESCRIPTION_MAX_LENGTH` in
 * backend/src/graphql/Post.ts and the `Posts` column widths (varchar(50) / varchar(350)).
 * Keep the three in step: the server rejects anything longer, and before these existed a long
 * post failed on submit against the database's accidental 255-character default, losing the text.
 */
export const POST_TITLE_LIMIT = 50;
export const POST_DESCRIPTION_LIMIT = 350;

/** Colour for a "312 / 350" counter: grey normally, amber near the limit, red past it. */
export const characterCountColour = (count: number, limit: number) => {
  const remaining = limit - count;
  if (remaining < 0) return '#b91c1c';
  if (remaining <= 20) return '#c2740a';
  return '#6b7280';
};
